import {Injectable, Inject} from '@angular/core';
import {Router} from '@angular/router';
import {ApiService, AuthenticateService, CookieService, LocalStorageService, EndpointService} from '@angular/synthrone-design/services';
import {Observable, Subject} from 'rxjs/Rx';
import {APP_CONFIG} from '@synthroneApp/app.config';

import {environment} from '@synthroneEnvironments/environment';

import * as io from 'socket.io-client';

@Injectable()
export class SynthroneDataService {


    constructor(protected api: ApiService,
                @Inject(APP_CONFIG) private config,
                private lsService: LocalStorageService,
                @Inject(AuthenticateService) private authenticateService,
                private cookieService: CookieService,
                private router: Router,
                private endpointService: EndpointService) {
    }

    logout = () => {
        this.cookieService.removeCookie('systemToken', false, true);
        this.cookieService.clearAll(true);
        this.lsService.clearAll(true);
        window.location.href = '/login?returnUrl=' + encodeURIComponent(window.location.href);
    }

    sdGetMenu = (): Observable<any> => {

        let data: any = [
            {
                elements: [
                    {
                        text: 'Dashboard',
                        icon: 'dashboard',
                        url: '/dashboard'
                    },
                    {
                        text: 'Maintenance',
                        icon: 'access_time',
                        url: '/maintenance'
                    },
                    {
                        text: 'Notifications',
                        icon: 'notifications_none',
                        url: '/notifications'
                    },
                    {
                        text: 'Login as...',
                        icon: 'assignment_ind',
                        url: '/users'
                    },
                    {
                        text: 'Organizations',
                        icon: 'business',
                        url: '/organizations'
                    },
                    {
                        text: 'Languages',
                        icon: 'translate',
                        url: '/languages'
                    },
                    {
                        text: 'Countries',
                        icon: 'language',
                        url: '/countries'
                    },
                    {
                        text: 'Sections',
                        icon: 'view_agenda',
                        url: '/sections'
                    },
                    // {
                    //     text: 'Components',
                    //     icon: 'extension',
                    //     url: '/components'
                    // },
                    {
                        text: 'Platforms',
                        icon: 'shopping_cart',
                        url: '/platforms'
                    },
                    {
                        text: 'Pipelines',
                        icon: 'dns',
                        url: '/pipelines'
                    },
                    {
                        text: 'Attributes',
                        icon: 'blur_circular',
                        children: [
                            {
                                elements: [
                                    {
                                        text: 'Manage all attributes',
                                        url: '/attributes'
                                    },
                                    {
                                        text: 'Manage attributes groups',
                                        url: '/attributes-groups'
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        text: 'Manage environment fonts',
                        icon: 'font_download',
                        url: '/fonts'
                    }
                ]
            }
        ];

        return Observable.of(data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/synthrone-data/synthrone-data.service.ts